import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const TransactionComponent = React.lazy(() => import("../Components/RootComponents/TransactionComponent"));
const TransactionPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <TransactionComponent />
      </Suspense>
    </Fragment>
  );
};

export default TransactionPage;
